import { PageHeader } from "../components/PageHeader";
import { CompanySettingsForm } from "../components/admin/CompanySettingsForm";
import { UsersPanel } from "../components/admin/UsersPanel";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../components/ui/tabs";

export default function Admin() {
  return (
    <div>
      <PageHeader eyebrow="Administration" title="Admin" />
      <Tabs defaultValue="company">
        <TabsList className="bg-zinc-200/60">
          <TabsTrigger data-testid="admin-tab-company" value="company">Company details</TabsTrigger>
          <TabsTrigger data-testid="admin-tab-users" value="users">Users</TabsTrigger>
        </TabsList>
        <TabsContent value="company" className="mt-6 max-w-4xl"><CompanySettingsForm /></TabsContent>
        <TabsContent value="users" className="mt-6"><UsersPanel /></TabsContent>
      </Tabs>
    </div>
  );
}
